<template>
  <div>
    <div>
    </div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="9000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card class="box">
      <v-row justify="center">
        <v-radio-group v-model="print_type" row>
          <v-radio label="Print Bulk Icards" value="NewBulk" color="success"></v-radio>
          <v-radio
            label="Print Specific Icards"
            value="NewSpecific"
            color="success"
          ></v-radio>
        </v-radio-group>
      </v-row>
      <template v-if="print_type == 'NewBulk'">
        <v-row dense justify="center">
          <v-col sm="3" md="3">
            <v-autocomplete
              class="no-display"
              :items="std_list"
              item-value="id"
              item-text="standard"
              v-model="std"
              label="Select Standard"
              dense
              :loading="loader"
              rounded
              outlined
              color="#0F2027"
            ></v-autocomplete>
          </v-col>
          <v-col sm="3" md="3">
            <v-autocomplete
              class="no-display"
              :items="div_list"
              item-value="id"
              item-text="division"
              v-model="div"
              label="Select Division"
              dense
              rounded
              outlined
              color="#0F2027"
            ></v-autocomplete>
          </v-col>
          <v-col sm="2">
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="status"
              :items="status_list"
              item-text="name"
              item-value="id"
              label="Status"
              outlined
              persistent-hint
              hint="Select Status"
            />
          </v-col>
          <v-col sm="2">
            <v-text-field
              dense
              rounded
              required
              outlined
              persistent-hint
              hint="Items Per Pages"
              v-model="itemsPerPage"
              label="Items Per Pages"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" v-if="std && div && status">
          <v-col cols="12" sm="4" md="2">
            <v-card @click="getRemainingStudentData()" height="55" class="pa-1" color="primary" style="color:white; border-radius: 50px;align-content: center;" hover >
              <center><span >Get Incomplete / Blocked Students List</span></center>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-card @click="NewBulk()" height="55" class="pa-1"  color="primary" style="color:white; border-radius: 50px;align-content: center;" hover>
              <center><span >Proceed to bulk<span class="i-card"> Icard</span><br> print</span></center>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-card @click="bulkEscort()" height="55" class="pa-1" color="primary" style="color:white; border-radius: 50px;align-content: center;" hover>
              <center><span >Proceed to bulk <span class="i-escort">Escort </span><br>
              print</span></center>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-card @click="FatherIcard()"  height="55" class="pa-1" color="primary" style="align-content: center; color:white; border-radius: 50px" hover>
              <center><span >Father Icard</span></center>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-card @click="MotherIcard()" height="55" class="pa-1" color="primary" style=" align-content: center;color:white; border-radius: 50px" hover>
              <center><span >Mother Icard</span></center>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <template v-if="print_type == 'NewSpecific'">
        <br />
        <v-row justify="center" dense>
          <v-col sm="5">
            <v-textarea
              v-model="prn"
              color="#0F2027"
              rounded
              dense
              label="Enter Comma Seperated PRN"
              outlined
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center" dense  v-if="prn">
          <v-card @click="getNewIcardsSpecificPRN()"  height="55" class="pa-3" color="primary" style="align-content: center; color:white; border-radius: 50px" hover>
              <center><span >Proceed To <span class="i-card"> Icard</span> print</span></center>
            </v-card>
        </v-row>
      </template>
    </v-card>
    <v-card
      class="box"
      v-if="icard_data_rem_students != '' && print_type != 'NewSpecific'"
    >
      <v-data-table
        :headers="headers"
        dense
        :items="icard_data_rem_students"
        class="elevation-1 mytable"
        :search="search"
      >
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Students</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              style="color: white; background-color: white"
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            >
            </v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:[`item.icard_blocked`]="{ item }">
          <span v-if="item.icard_blocked">
            <v-icon small class="mr-2 v-icon-size" color="success"
              >mdi-check-circle-outline</v-icon
            >
          </span>
          <span v-else>
            <v-icon small class="mr-2 v-icon-size" color="error"
              >mdi-close-circle-outline</v-icon
            >
          </span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    prn: "",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    search: "",
    itemsPerPage: 10,
    headers: [
      {
        text: "Student",
        align: "left",
        sortable: false,
        value: "grno",
      },
      {
        text: "Data Remaining",
        align: "left",
        sortable: false,
        value: "icard_fields_remaining",
      },
      {
        text: "Is Icard Blocked?",
        align: "left",
        sortable: false,
        value: "icard_blocked",
      },
    ],
    loader: false,
    icard_status: null,
    icard_data_rem_students: [],
    icard_temp: [],
    comp_load: false,
    stud_list: null,
    radios: null,
    stud_data: null,
    child_data: null,
    icard_data: [],
    print_type: null,
    std_list: null,
    div_list: null,
    std: null,
    active_status: null,
    div: null,
    status_list: [
      { name: "Active", id: "0" },
      { name: "Temporary Inactive", id: "1" },
      { name: "Permanent Inactive", id: "2" },
    ],
    status: "0",
    icard_fields_remaining: null,
    icard_data: [],
    common_data: [],
    aadhar_icardname: false,
  }),
  mounted() {
    this.onload();
    localStorage.setItem("icard_std_id", null);
    localStorage.setItem("icard_div_id", null);
    localStorage.setItem("icard_data", null);
    localStorage.setItem("common_data", null);
  },
  methods: {
    getNewIcardsSpecificPRN() {
      localStorage.setItem("prn", JSON.stringify(this.prn));
      let routeData = this.$router.resolve({
              name: "wws-stud-new-specific-card-print",
            });
            window.open(routeData.href, "_blank");
    },
    getRemainingStudentData() {
      this.icard_data_rem_students = [];
      const data = {
        std: this.std,
        div: this.div,
        status: this.status,
      };
      axios
        .post("/Icard/getIcardIncompleteStudent", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.icard_data_rem_students = res.data.icard_data;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          }
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    NewBulk() {
      localStorage.setItem("icard_std_id", this.std);
      localStorage.setItem("icard_div_id", this.div);
      localStorage.setItem("icard_learner_status", this.status);
      localStorage.setItem("itemsPerPage", this.itemsPerPage);
      let routeData = this.$router.resolve({
        name: "wws-stud-new-bulk-card-print",
      });
      window.open(routeData.href, "_blank");
    },
    bulkEscort() {
      localStorage.setItem("icard_std_id", this.std);
      localStorage.setItem("icard_div_id", this.div);
      localStorage.setItem("icard_learner_status", this.status);
      let routeData = this.$router.resolve({
        name: "wws-stud-bulk-escort-print",
      });
      window.open(routeData.href, "_blank");
    },
    FatherIcard() {
      localStorage.setItem("icard_std_id", this.std);
      localStorage.setItem("icard_div_id", this.div);
      localStorage.setItem("icard_learner_status", this.status);
      let routeData = this.$router.resolve({
        name: "wws-father-icard-print",
      });
      window.open(routeData.href, "_blank");
    },
    MotherIcard() {
      localStorage.setItem("icard_std_id", this.std);
      localStorage.setItem("icard_div_id", this.div);
      localStorage.setItem("icard_learner_status", this.status);
      let routeData = this.$router.resolve({
        name: "wws-mother-icard-print",
      });
      window.open(routeData.href, "_blank");
    },
    onload() {
      this.loader = true;
      axios.post("/admission/getAllStudents1").then((res) => {
        if (res.data.msg == "200") {
          this.stud_list = res.data.stud_list;
          this.std_list = res.data.std_list;
          this.div_list = res.data.div_list;
          this.loader = false;
        } else {
          this.showSnackbar("error", "Something went wrong!!!");
        }
      });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>

<style scoped>
h2 {
  font-size: 1.2em;
}
tr,
td {
  width: 100%;
}
th {
  text-align: left;
  font-size: 0.7em;
  padding-right: 15px;
  padding-left: 6px;
}
.i-escort {
  font-size: medium;
  margin-left: 2px;
  margin-right: 2px;
  color: #ffeb3b;
}
.i-card {
  color: greenyellow;
  font-size: medium;
  margin-left: 2px;
  margin-right: 2px;
}

</style>
